import React, { Fragment, useState, useEffect } from "react";
import { Col, Form, Container, Row } from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { UPDATE_PAYMENT_METHOD } from "../../../../src/store/types";

const MemoPaymentMain = ({ payment, onChangePayMethod, ...props }) => {
  const [selectedValue, setSelectedValue] = useState(0);
  const onChangePaymentType = (id) => {
    setSelectedValue(id);
  };

  useEffect(() => {
    onChangePayMethod(selectedValue);
  }, [selectedValue]);

  return (
    <React.Fragment>
      <MuiThemeProvider theme={theme}>
        <Container fluid>
          <h3>Payment</h3>
          <div style={{ paddingTop: "2%" }}>
            {/* <PhoneComponent
                            mobile_number={
                                props &&
                                props.user_data &&
                                props.user_data.user_details &&
                                props.user_data.user_details.mobile_number
                            }
                            country_code={
                                props &&
                                props.user_data &&
                                props.user_data.user_details &&
                                props.user_data.user_details.country_code
                            }
                        /> */}
            <hr />

            <Container fluid>
              <br />
              <Row
                style={{
                  backgroundColor: "#FFFBEE",
                  padding: "15px",
                  display: "flex",
                }}
                className="align-middle"
              >
                <p style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                  ₹{" "}
                  {payment?.refund
                    ? (payment?.refund)
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                    : 0}
                </p>
                <p style={{ color: "#212121" }}>Total Amount To Be Paid</p>
              </Row>
              <hr />
              <h5>Select payment method</h5>
              <br />
              {paymentData.map((data, index) => {
                return (
                  <Fragment key={index}>
                    {data.show ? (
                      <PaymentsInfo
                        data={data}
                        selectedValue={selectedValue}
                        handlePaymentType={() => onChangePaymentType(data.id)}
                      />
                    ) : (
                      <Fragment></Fragment>
                    )}
                  </Fragment>
                );
              })}
            </Container>
          </div>
        </Container>
      </MuiThemeProvider>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default withRouter(connect(mapStateToProps, null)(MemoPaymentMain));

const theme = createTheme({
  palette: {
    primary: { main: "#EE3A23" }, // Purple and green play nicely together.
    secondary: { main: "#9E9E9E" }, // This is just green.A700 as hex.
  },
});

const PaymentsInfo = (props) => {
  const [data, setData] = React.useState(props.data);
  const [view, setView] = React.useState(false);
  return (
    <div>
      <Row style={{ backgroundColor: "#ffffff", padding: "15px" }}>
        <Col md={1}>
          <Radio
            checked={data.id === props.selectedValue ? true : false}
            onChange={(e) => {
              setView(true);
              props.handlePaymentType(e.target.value);
            }}
            value={data.value}
            name="radio-button-demo"
            color="primary"
            inputProps={{ "aria-label": data.value }}
          />
        </Col>
        <Col md={1}>
          <img src={data.icon} />
        </Col>
        <Col md={8}>
          <b>{data.title}</b>
        </Col>
        <Col md={2}>arrow</Col>
      </Row>
    </div>
  );
};

export const PhoneComponent = (props) => {
  return (
    <Row>
      <Col xs={12} md={8}>
        <Row>
          <Col xs={4} className="pr-0">
            <Form.Group controlId={"country_code"}>
              <FormControl variant="outlined" className="w-100">
                <Select
                  disabled
                  value={+91}
                  // onChange={handleChangeCode}
                  inputProps={{
                    name: "code",
                  }}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <option value={+91}>{props.country_code}</option>
                </Select>
              </FormControl>
            </Form.Group>
          </Col>
          <Col xs={8}>
            <Form.Group>
              <TextField
                disabled
                id="outlined-basic"
                label="Phone Number"
                variant="outlined"
                className="w-100"
                value={props.mobile_number}
              />
            </Form.Group>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const paymentData = [
  {
    id: 6,
    title: "Pay later",
    value: "Pay later",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 9,
    title: "Cash",
    value: "Cash",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 8,
    title: "External Wallet",
    value: "Wallet",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 1,
    title: "BHIM UPI",
    value: "BHIM UPI",
    icon: require("../../../assets/images/Orders/sdmlM4R-_400x400.png"),
    show: false,
  },
  {
    id: 2,
    title: "PayTM",
    value: "PayTM",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: false,
  },
  {
    id: 3,
    title: "Debit Card",
    value: "Debit Card",
    icon: require("../../../assets/images/superadmin/ordericon/credit-card (1).svg"),
    show: true,
  },
  {
    id: 4,
    title: "Credit Card",
    value: "Credit Card",
    icon: require("../../../assets/images/superadmin/ordericon/phone-credit card-money-finance.svg"),
    show: true,
  },
  {
    id: 5,
    title: "Net Banking",
    value: "Net Banking",
    icon: require("../../../assets/images/superadmin/ordericon/online-payment.svg"),
    show: false,
  },
];
